module.exports = __webpack_public_path__ + "img/bth_beibu_pre.a4909403.png";